import { createStore } from "vuex";

import { setStore, getStore } from "@/utils/store";

import getters from "./getters";

const store = createStore({
  state: {
    // 相当于data属性
    num: getStore({ name: "num" }),
    childnum: getStore({ name: "childnum" }),
    childnum1: getStore({ name: "childnum1" }),

    // 主题
    themeItem: getStore({ name: "themeItem" }),
    themeList: getStore({ name: "themeList" }),
  },
  getters: {
    // 计算属性
  },
  mutations: {
    // 同步处理，state中的属性值，只能在这里修改
    SET_NUM(state, num) {
      state.num = num;
      setStore({ name: "num", content: state.num, type: "session" });
    },
    SET_CHILDNUM(state, num) {
      state.childnum = num;
      setStore({ name: "childnum", content: state.childnum, type: "session" });
    },
    SET_CHILDNUM1(state, num) {
      state.childnum1 = num;
      setStore({
        name: "childnum1",
        content: state.childnum1,
        type: "session",
      });
    },

    SET_THEMEITEM(state, val) {
      state.themeItem = val;

      setStore({
        name: "themeItem",
        content: state.themeItem,
        type: "session",
      });
    },

    SET_THEMELIST(state, val) {
      state.themeList = val;

      setStore({
        name: "themeList",
        content: state.themeList,
        type: "session",
      });
    },

  },
  actions: {
    // 异步处理
  },
  modules: {
    // 模块
  },
  getters,
});

// 导出
export default store;
